import { render, staticRenderFns } from "./CheckoutSettings.vue?vue&type=template&id=ef327350&scoped=true&"
import script from "./CheckoutSettings.vue?vue&type=script&lang=js&"
export * from "./CheckoutSettings.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSettings.vue?vue&type=style&index=0&id=ef327350&prod&lang=scss&"
import style1 from "./CheckoutSettings.vue?vue&type=style&index=1&id=ef327350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef327350",
  null
  
)

export default component.exports